import { Segment } from '../leaflet-map.types';

type GenerateCircleSegmentsParams = {
    segments: Segment[];
    centerPoint: number;
    radius: number;
    strokeWidth: number;
};

export const generateCircleSegments = ({
    segments,
    centerPoint,
    radius,
    strokeWidth,
}: GenerateCircleSegmentsParams): string => {
    return segments
        .map(segment => {
            return `<circle
                cx="${centerPoint}"
                cy="${centerPoint}"
                r="${radius}"
                fill="transparent"
                stroke="${segment.color}"
                stroke-width="${strokeWidth}"
                stroke-dasharray="${segment.dashArray}"
                stroke-dashoffset="${segment.dashOffset}"
                class="charger-marker-segment-circle"
            ></circle>`;
        })
        .join('');
};
